import gql from 'graphql-tag';
import UserFragments from '../fragments/user.fragments';

const mutation = gql`
  mutation Login($params: LoginUserParams!) {
    login(params: $params) {
      user {
        ...UserFields
        ...UserAddress
        ...UserInvestorProfile
        ...UserLicenses
        ...UserProfileImageFile
        ...UserOAuthProviders
        ...UserNotificationSettings
        ...UserContacts
      }
      token
      hubspotToken
    }
  }

  ${UserFragments.fields}
  ${UserFragments.address}
  ${UserFragments.investorProfile}
  ${UserFragments.licenses}
  ${UserFragments.profileImageFile}
  ${UserFragments.oAuthProviders}
  ${UserFragments.notificationSettings}
  ${UserFragments.contacts}
`;

export default mutation;
